import CurrentMeetingControls from "./current-meeting-controls";
import { CurrentMeetingDetails } from "./current-meeting-details";
import { CurrentMeetingPreview } from "./current-meeting-preview";

export const CurrentMeetingActionsAndDetails = () => (
  <div className="current-meeting-details-wrap">
    <CurrentMeetingDetails />
    <div className="divider-vertical" />
    <CurrentMeetingControls />
    <CurrentMeetingPreview />
  </div>
);
